export const transmissionTaskAction = {
  loadReportTaskList: (state, action) => {
    const payload = action.payload;

    const existTask =
      payload &&
      state.taskList?.length > 0 &&
      state.taskList?.some((task) => task?.description === payload);

    if (typeof payload === "string" && existTask === false) {
      state.taskList.push(payload);
    } else {
      state.taskList = action.payload;
    }

    state.currentTask = {};
  },
  onReportTaskInputFocus: (state, action) => {
    state.taskFocused = action.payload;
  },
  cancelReportTask: (state, action) => {
    const { focused } = action.payload;

    state.currentTask = {};
    state.taskFocused = focused;
    state.isEditReportTask = false;
  },
  editReportTask: (state, action) => {
    state.isEditReportTask = action.payload;
  },
  setReportInterval: (state, action) => {
    state.reportInterval = action.payload;
  },
  setUseReportIntervalFilter: (state, action) => {
    state.useReportIntervalFilter = action.payload;
  },
};
